// https://github.com/cheton/styled-ui/tree/dev/packages/styled-theme
// TODO: When `styled-theme` is ready, we need to use ths `base` object from that library instead.

// XXX: Map `Style-portal` to `styled-theme`
//
// `style-portal` http://style-portal.tw.trendnet.org?mode=light#/styles/minimalism/latest/ce531d75-4d1c-4f45-986a-793ee0c958e0
// `styled-theme` https://github.com/cheton/styled-ui/blob/29194d97ec1dee1f1e7bc15c296c97dcaeb2d637/packages/styled-theme/src/base.js#L52-L187
//
// primary: '#222222'     =>  // blackAlpha.primary
// error: '#db3d44'       =>  // red:80
// warning: '#ff7633'     =>  // orange:50
// mute: '#888888'        =>  // gray:100
// unsupported: '#aaaaaa' =>  // gray:80
// hypertext: '#0096cc'   =>  // blue:80

const colors = {
    transparent: 'transparent',
    current: 'currentColor',

    'red:100': '#c22327',
    'red:90': '#cd363a',
    'red:80': '#db3d44',
    'red:70': '#e15054',
    'red:60': '#e56669',
    'red:50': '#e6777c',
    'red:40': '#e98b8f',
    'red:30': '#f3c0c3',
    'red:20': '#f8dcdd',
    'red:10': '#fde8e9',

    'magenta:100': '#750037',
    'magenta:90': '#960043',
    'magenta:80': '#b3004c',
    'magenta:70': '#ca0455',
    'magenta:60': '#dc1d68',
    'magenta:50': '#e94181',
    'magenta:40': '#f36fa0',
    'magenta:30': '#f9a0c1',
    'magenta:20': '#fcc3d8',
    'magenta:10': '#fee1ec',

    'purple:100': '#460086',
    'purple:90': '#5300a5',
    'purple:80': '#6304ca',
    'purple:70': '#771ddc',
    'purple:60': '#8f41e9',
    'purple:50': '#ab6ff3',
    'purple:40': '#bb89f6',
    'purple:30': '#cca6f9',
    'purple:20': '#ddc3fc',
    'purple:10': '#eee1fe',

    'blue:100': '#036f96',
    'blue:90': '#0382b0',
    'blue:80': '#0096cc',
    'blue:70': '#33abd6',
    'blue:60': '#4cb5db',
    'blue:50': '#66c0e0',
    'blue:40': '#7fcae5',
    'blue:30': '#99d5eb',
    'blue:20': '#cceaf5',
    'blue:10': '#e6f4fc',

    'green:100': '#003011',
    'green:90': '#00461a',
    'green:80': '#005c24',
    'green:70': '#00712e',
    'green:60': '#008539',
    'green:50': '#00a94f',
    'green:40': '#04c45a',
    'green:30': '#40e884',
    'green:20': '#89f6b2',
    'green:10': '#c3fcd8',

    'teal:100': '#004034',
    'teal:90': '#005242',
    'teal:80': '#006451',
    'teal:70': '#00755f',
    'teal:60': '#00866c',
    'teal:50': '#00a584',
    'teal:40': '#04caa1',
    'teal:30': '#4119c5',
    'teal:20': '#89f6df',
    'teal:10': '#c3fcf0',

    'cyan:100': '#003664',
    'cyan:90': '#004575',
    'cyan:80': '#005486',
    'cyan:70': '#006496',
    'cyan:60': '#0075a5',
    'cyan:50': '#0095bf',
    'cyan:40': '#10b4d3',
    'cyan:30': '#41d8e9',
    'cyan:20': '#89f0f6',
    'cyan:10': '#c3f9fc',

    'gray:140': '#222222',
    'gray:130': '#444444',
    'gray:120': '#666666',
    'gray:110': '#777777',
    'gray:100': '#888888',
    'gray:90': '#999999',
    'gray:80': '#aaaaaa',
    'gray:70': '#bbbbbb',
    'gray:60': '#cccccc',
    'gray:50': '#dddddd',
    'gray:40': '#e6e6e6',
    'gray:30': '#eeeeee',
    'gray:20': '#f4f4f4',
    'gray:10': '#f8f8f8',

    'orange:50': '#ff7633',

    'yellow:50': '#faca2a',

    'white:emphasis': 'rgba(255, 255, 255, 1.0)',
    'white:primary': 'rgba(255, 255, 255, .92)',
    'white:secondary': 'rgba(255, 255, 255, .60)',
    'white:tertiary': 'rgba(255, 255, 255, .47)',
    'white:disabled': 'rgba(255, 255, 255, .28)',

    'black:emphasis': 'rgba(0, 0, 0, .92)',
    'black:primary': 'rgba(0, 0, 0, .92)',
    'black:secondary': 'rgba(0, 0, 0, .65)',
    'black:tertiary': 'rgba(0, 0, 0, .54)',
    'black:disabled': 'rgba(0, 0, 0, .30)',
};

const space = {
    0: '0',

    xs: '.125rem', // 2px
    sm: '.25rem', // 4px
    md: '.5rem', // 8px
    lg: '.75rem', // 12px
    xl: '1rem', // 16px

    '1x': '.25rem', // 4px
    '2x': '.5rem', // 8px
    '3x': '.75rem', // 12px
    '4x': '1rem', // 16px
    '5x': '1.25rem', // 20px
    '6x': '1.5rem', // 24px
    '7x': '1.75rem', // 28px
    '8x': '2rem', // 32px
    '9x': '2.25rem', // 36px
    '10x': '2.5rem', // 40px
    '12x': '3rem', // 48px
    '16x': '4rem', // 64px
    '20x': '5rem', // 80px
    '24x': '6rem', // 96px
    '32x': '8rem', // 128px
    '40x': '10rem', // 160px
    '48x': '12rem', // 192px
    '56x': '14rem', // 224px
    '64x': '16rem', // 256px
};

const fonts = {
    heading: 'Interstate-Light, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif',
    base: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif',
    mono: 'Interstate-Light, Arial, "Helvetica Neue", Helvetica, sans-serif',
};

const fontWeights = {
    thin: 100,
    extralight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
};

const fontSizes = {
    xs: '.75rem', // font-size: 12px, line-height: 18px
    sm: '.875rem', // font-size: 14px, line-height: 20px
    md: '1rem', // font-size: 16px, line-height: 22px
    lg: '1.125rem', // font-size: 18px, line-height: 24px
    xl: '1.25rem', // font-size: 20px, line-height: 28px
    '2xl': '1.5rem', // font-size: 24px, line-height: 32px
    '3xl': '1.75rem', // font-size: 28px, line-height: 36px
    '4xl': '2rem', // font-size: 32px, line-height: 40px
};

const lineHeights = {
    xs: '1.125rem', // font-size: 12px, line-height: 18px
    sm: '1.25rem', // font-size: 14px, line-height: 20px
    md: '1.375rem', // font-size: 16px, line-height: 22px
    lg: '1.5rem', // font-size: 18px, line-height: 24px
    xl: '1.75rem', // font-size: 20px, line-height: 28px
    '2xl': '2rem', // font-size: 24px, line-height: 32px
    '3xl': '2.25rem', // font-size: 28px, line-height: 36px
    '4xl': '2.5rem', // font-size: 32px, line-height: 40px

    normal: 'normal',
    base: '1.5',
};

const zIndices = {
    hide: -1,
    auto: 'auto',
    base: 0,
    dropdown: 1000,
    sticky: 1100,
    fixed: 1200,
    overlay: 1300,
    drawer: 1400,
    modal: 1500,
    popover: 1600,
    toast: 1700,
    tooltip: 1800,
};

export default {
    colors,
    fonts,
    fontWeights,
    fontSizes,
    lineHeights,
    space,
    zIndices
};
